import { useState, useEffect } from "react";
import { zoomChange } from "Threejs/camera";

const useInput = (init: number) => {
	const [value, setValue] = useState(init);

	useEffect(() => {
		zoomChange(value);
	}, [value]);

	const onChange = (e: any) => {
		const newValue = +e.target.value;
		setValue(newValue);
	};

	return { value, onChange, setValue };
};

export default useInput;
